import type { Messages } from './en';

/** 第二階段內容：新地點（運動中心、購物中心、馬場、保健室、音樂教室）與新角色（繁體中文・台灣）。 */
export const zhTWPlaces: Pick<Messages, 'places' | 'talks2'> = {
  places: {
    zones: {
      gym: '體育館', pool: '游泳池', nurse: '保健室', music: '音樂教室', cafe: '小燈籠咖啡館',
      giftShop: '禮品店', dept: '百貨公司', restaurant: '餐廳', mall: '燈籠購物中心',
      sportsCenter: '運動中心', tennis: '網球場', volley: '沙灘排球場', stable: '騎馬場',
    },
    mapNames: { sports: '運動中心', mall: '燈籠購物中心' },
    objects: {
      nurseDesk: '護理師的桌子', pool: '游泳池', gymNet: '排球網', tennisNet: '網球場', volleyNet: '排球場',
      fountain: '噴水池', cafeCounter: '咖啡館櫃檯', giftCounter: '禮品櫃檯', deptCounter: '結帳櫃檯', restCounter: '餐廳櫃檯',
    },
    npc: {
      nurse: '謝護理師', musicTeacher: '郭老師', lifeguard: '救生員安安', barista: '小美', giftClerk: '露露',
      deptClerk: '潘先生', waiter: '阿湯', stableKeeper: '吳伯伯', horse: '馬兒', pony: '小馬',
    },
    items: {
      flowers: { name: '花束', desc: '收到的人一定會笑出來的禮物。' },
      scarf: { name: '圍巾', desc: '軟綿綿、暖呼呼的禮物。' },
      keychain: { name: '可愛鑰匙圈', desc: '送朋友的小禮物。' },
      toy: { name: '玩具車', desc: '小朋友最愛了。' },
      sandwich: { name: '三明治', desc: '吃下去：+14 體力' },
      cocoa: { name: '外帶熱可可', desc: '喝下去：+12 體力、+4 心情' },
    },
    shops: {
      cafe: { title: '☕ 小燈籠咖啡館', hint: '熱飲和小點心。' },
      gift: { title: '🎁 禮品店', hint: '收到禮物大家都會很開心。聊天的時候送給他們吧！' },
      dept: { title: '👕 百貨公司', hint: '換上新衣服，造型馬上就不一樣喔。' },
    },
    outfits: ['學校制服', '天藍色帽T', '櫻花洋裝', '紅色運動風', '森林綠'],
    outfitOn: (name: string) => `你現在穿的是：${name}`,
    restaurant: {
      title: '🍜 餐廳菜單',
      hint: '坐下來好好吃一頓（+體力、+心情）。',
      dishes: [
        { name: '牛肉麵', desc: '+35 體力' },
        { name: '水餃（10 顆）', desc: '+30 體力、+5 心情' },
        { name: '蔬菜炒飯', desc: '+28 體力、+3 學業（補腦食物！）' },
      ],
      eaten: (d: string) => `好好吃！你吃完了${d}。`,
      full: '你今天已經吃得好飽，吃不下另一餐了。',
    },
    nurse: {
      text: '保健室裡有乾淨床單和薰衣草的味道。',
      checkup: '做個健康檢查（+體力）',
      checkupDone: '謝護理師幫你量了體溫。「都很好喔！稍微休息一下，記得多喝水。」',
      bandage: '問問急救的方法',
      bandageText: '小傷口的話：先用乾淨的水沖洗，輕輕壓住止血，再貼上OK繃。如果傷口很深，一定要告訴大人喔！',
      already: '你今天已經做過檢查囉。要好好照顧自己！',
    },
    pool: {
      text: '天窗灑下的陽光讓池水閃閃發亮。救生員正在看著大家。',
      swim: '游幾趟（−體力、+心情）',
      swimDone: '噗通！你游了十趟，覺得自己又強壯又神清氣爽！',
      tired: '你太累了，這樣游泳不安全。先休息一下吧！',
      rules: '泳池規則',
      rulesText: '1. 下水前先淋浴。2. 池邊不可以奔跑。3. 要和夥伴一起游。4. 聽從救生員的指示。',
    },
    rally: {
      tennis: '網球對打',
      volley: '排球練習',
      text: '球來了！會落在哪裡呢？',
      left: '左邊', center: '中間', right: '右邊',
      hit: '漂亮的回擊！',
      miss: '沒接到！眼睛要盯著球喔……',
      done: (n: number) => `對打結束：好球 ${n}/3！`,
    },
    fountain: {
      text: '噴水池底的硬幣閃閃發光。',
      wish: '丟一枚硬幣許個願（1🪙）',
      wishDone: '叮咚！你為家人和朋友許了一個願。',
      noCoin: '你身上沒有硬幣耶。',
    },
    horse: {
      text: '一匹溫柔的馬兒用鼻子蹭蹭你的手。',
      ride: '騎上馬兒（記得戴安全帽！）',
      dismount: '下馬',
      riding: '你騎上馬了！在圍場裡逛逛吧。',
      leave: '馬兒在柵欄前停下來了。騎馬只能在圍場裡面喔。',
      feed: '餵牠一根紅蘿蔔（+心情）',
      fed: '喀滋喀滋！馬兒看起來超開心的。',
    },
    scenarios: {
      swim: '詢問泳池規則', tennis: '學習網球發球', horse: '安全地騎馬',
      clothes: '去買衣服', music: '參加音樂課', art: '聊聊你的畫',
    },
    gifts: {
      give: '🎁 送禮物',
      pick: '要送哪一個禮物？',
      thanks: ['哇！要給我的嗎？真的太謝謝你了！', '你好貼心喔！我超喜歡的！', '好棒的驚喜！'],
    },
  },
  /** 新角色的閒聊（格式和 `talks` 相同）。 */
  talks2: {
    nurse: {
      greet: { morning: ['早安！身體還好嗎？'], afternoon: ['你好呀，需要什麼嗎？'], evening: ['還在學校啊？別忘了好好休息喔。'] },
      topics: [
        {
          say: '你知道為什麼睡覺這麼重要嗎？',
          choices: [
            { t: '它可以幫助身體長大、修復。', reply: '答對了！而且大腦會趁睡覺時整理你學到的東西。' },
            { t: '我應該睡幾個小時？', reply: '你這個年紀大概要睡九到十個小時喔。' },
            { t: '那我可以在課堂上睡嗎？', reply: '哈哈！晚上睡覺，上課學習啦。' },
          ],
        },
        {
          say: '洗手是保持健康最簡單的方法。',
          choices: [
            { t: '我吃飯前一定會洗手！', reply: '好習慣！用肥皂洗二十秒喔！' },
            { t: '為什麼要二十秒？', reply: '因為肥皂需要這麼久才能把細菌分解掉。' },
            { t: '那我邊洗手邊唱歌。', reply: '太好了——〈生日快樂歌〉唱兩遍差不多就是二十秒！' },
          ],
        },
      ],
    },
    musicTeacher: {
      greet: { morning: ['早安！我們來玩音樂吧。'], afternoon: ['喔，小音樂家來了！'], evening: ['回家前再來一首？'] },
      topics: [
        {
          say: '音樂就像一種語言，每個人都學得會。',
          choices: [
            { t: '我想學鋼琴！', reply: '太棒了。先從單手開始，慢慢來。' },
            { t: '老師第一個學的樂器是什麼？', reply: '直笛！聲音很尖，可是我好喜歡。' },
            { t: '我可以學打鼓嗎？大聲的那種？', reply: '哈哈，可以啊。先練節奏，再來比大聲。' },
          ],
        },
        {
          say: '你開心的時候會唱歌嗎？',
          choices: [
            { t: '會！唱完心情更好了。', reply: '大家都說，音樂能讓快樂加倍。' },
            { t: '難過的時候唱歌有用嗎？', reply: '常常有用喔。溫柔的歌可以讓心情平靜下來。' },
            { t: '只有洗澡的時候會唱。', reply: '浴室的回音效果最好了！' },
          ],
        },
      ],
    },
    lifeguard: {
      greet: { morning: ['早上來游泳？先暖身喔！'], afternoon: ['今天的水溫剛剛好。'], evening: ['游最後幾趟就回家囉！'] },
      topics: [
        {
          say: '就算你很會游泳，也絕對不要一個人游。',
          choices: [
            { t: '知道了，一定要有夥伴！', reply: '這就是規則。安全第一。' },
            { t: '如果有人需要幫忙怎麼辦？', reply: '大聲叫大人或救生員，再丟一個會浮的東西給他。千萬不要自己跳下去。' },
            { t: '我的小黃鴨可以當我的夥伴嗎？', reply: '哈！只有真人夥伴才算數喔。' },
          ],
        },
      ],
    },
    barista: {
      greet: { morning: ['早安！可頌剛出爐喔！'], afternoon: ['歡迎來到小燈籠！'], evening: ['晚安！大人喝低咖啡因，你喝熱可可。'] },
      topics: [
        {
          say: '這間咖啡館是轉角商店的阿凱幫我一起開的喔！',
          choices: [
            { t: '好棒喔！這裡好溫馨。', reply: '謝謝你！我們每張桌子都放了一盆小植物。' },
            { t: '妳最喜歡喝什麼？', reply: '加一點肉桂的熱可可。' },
            { t: '有隱藏菜單嗎？', reply: '噓……點「燈籠特調」就對了，裡面有棉花糖喔。' },
          ],
        },
      ],
    },
    giftClerk: {
      greet: { morning: ['你好！在找禮物嗎？'], afternoon: ['歡迎光臨！每樣東西都免費包裝喔。'], evening: ['臨時要買禮物？我來幫你！'] },
      topics: [
        {
          say: '最好的禮物，是讓對方知道你真的有在想著他。',
          choices: [
            { t: '我會挑他真正喜歡的東西。', reply: '這就是秘訣。多聽聽大家喜歡什麼。' },
            { t: '大家最常買什麼？', reply: '買花送媽媽，買鑰匙圈送朋友。' },
            { t: '我可以送禮物給自己嗎？', reply: '哈哈，偶爾可以啊！犒賞一下自己。' },
          ],
        },
      ],
    },
    deptClerk: {
      greet: { morning: ['早安。新的季節，新的款式！'], afternoon: ['歡迎光臨。都可以試穿喔！'], evening: ['我們九點打烊。'] },
      topics: [
        {
          say: '穿讓自己覺得舒服、有自信的衣服就對了。',
          choices: [
            { t: '我喜歡鮮豔的顏色！', reply: '那就試試櫻花洋裝或紅色運動套裝吧！' },
            { t: '今年流行什麼？', reply: '帽T。軟軟的、暖暖的，還有口袋。' },
            { t: '有超級英雄的披風嗎？', reply: '可惜沒有。目前還沒有啦。' },
          ],
        },
      ],
    },
    waiter: {
      greet: { morning: ['我們十一點才開，不過先進來坐吧！'], afternoon: ['一位嗎？'], evening: ['晚安！今晚客人好多喔。'] },
      topics: [
        {
          say: '我們的牛肉麵，湯頭要熬六個小時。',
          choices: [
            { t: '哇，難怪這麼好吃！', reply: '謝謝你！主廚聽了一定很得意。' },
            { t: '還有什麼好吃的？', reply: '水餃。每天早上都是手工包的。' },
            { t: '我可以先吃甜點嗎？', reply: '除非你答應等一下會把青菜吃完！' },
          ],
        },
      ],
    },
    stableKeeper: {
      greet: { morning: ['早啊！馬兒們肚子餓了。'], afternoon: ['想跟馬兒打個招呼嗎？'], evening: ['馬兒們要休息囉。'] },
      topics: [
        {
          say: '靠近馬的時候一定要從側面，讓牠看得到你。',
          choices: [
            { t: '我會溫柔、冷靜一點。', reply: '很好。馬感覺得到你緊不緊張喔。' },
            { t: '馬喜歡吃什麼？', reply: '乾草、紅蘿蔔和蘋果。絕對不能給巧克力！' },
            { t: '馬會說話嗎？', reply: '用耳朵說！耳朵往前就是在好奇喔。' },
          ],
        },
      ],
    },
  },
};
